import { ConnetionRequestSource } from '../connectionRequests/connectionRequestTypes';

export interface AccountManagementSegmentState {
    id: string;
    name: string;
    key: string;
}

export interface ConnectionRequestState {
    id: string;
    requestDate: string | Date;
    requestedBy: ConnetionRequestSource | null;
    resolutionDate: string | Date;
    statusKey: string;
}

export interface MemberState {
    id: string;
    name: string;
    address: string;
    country: string;
    countryCode: string;
    idCountry: number;
    logo: string;
    idAccountManagementSegment: number;
    accountManagementSegment: string;
    statusKey: ZinantisRelationshipStatusTypeKeys;
    status: string;
    statusColor: string;
    descriptions: ZinantisMemberDescriptionState[];
    hotels: ZinantisMemberHotelsState[];
    allHotels: boolean;
    website?: string;
    signedDate: Date | null;
    isNew: boolean;
    bookingCodePrefix?: string;
    connectionRequests: ConnectionRequestState[];
}

export interface MembersFilters {
    name: string;
    idCountry: number | null; //int
    connexion:
        | 'all'
        | ZinantisRelationshipStatusTypeKeys.CONFIRMED
        | ZinantisRelationshipStatusTypeKeys.PENDING
        | ZinantisRelationshipStatusTypeKeys.DISCONNECTED;
    idAccountManagementSegment: number | null;
}

export interface ZinantisMemberHotelsState {
    id: string;
    idHotel: number; //int
    hotelName: string;
    idSupplierHotel: number; //int
    status: string;
    statusKey: string;
    statusColor: string;
    descriptions: ZinantisMemberDescriptionState[];
    city: string;
}

export enum ZinantisRelationshipStatusTypeKeys {
    CONFIRMED = 'CONFIRMED',
    PENDING = 'PENDING',
    REJECTED = 'REJECTED',
    DISCONNECTED = 'DISCONNECTED',
}

export interface ZinantisStatusState {
    key: ZinantisRelationshipStatusTypeKeys;
    text: string;
    color: string;
}

export interface OwnerZinantisAgenciesState {
    id: string;
    idAgency: number;
    statusKey: ZinantisRelationshipStatusTypeKeys;
    status: string;
    statusColor: string;
    descriptions: ZinantisMemberDescriptionState[];
    hotels: ZinantisMemberHotelsState[];
    connectionRequests: ConnectionRequestState[];
}

export interface ZinantisMemberDescriptionState {
    id: string;
    description: string;
    idContentLanguage: number; //int
    language: string;
    code: string;
}
